import axios, { isAxiosError } from 'axios';
import AuthInterceptor from '@Services/AuthInterceptor';
import SourceKeyInterceptor from '@Services/SourceKeyInterceptor';

function responseErrorInterceptor(error) {
  if (!isAxiosError(error)) {
    return Logger.reject(error);
  }

  const { response } = error;
  const errorResponse = response || error.toJSON();

  if (!errorResponse.status) {
    errorResponse.status = -1;
  }

  return AuthInterceptor.responseError(errorResponse);
}

export default function init() {
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use(AuthInterceptor.request);
  axios.interceptors.request.use(SourceKeyInterceptor.request);
  axios.interceptors.response.use(AuthInterceptor.response, responseErrorInterceptor);
}
